import { ListChecks } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export function DeliveryToolsRecommendation() {
  return (
    <Alert className="border-violet-200 bg-violet-50/70">
      <ListChecks aria-hidden="true" className="h-4 w-4 text-violet-700" />
      <AlertTitle className="text-violet-950">
        Recommended order-tool setup
      </AlertTitle>
      <AlertDescription className="text-violet-900">
        For a complete CRM and delivery workflow, enable Capture Customer Info,
        Update Opportunity Fields, Move Status/Stage, and the required Delivery tools
        for each order-taking agent. Product-price verification and delivery tracking are optional.
      </AlertDescription>
    </Alert>
  )
}
